<template>
  <div>
    <div
      class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap mb-3">
      <el-select
        class="select-primary pagination-select"
        v-model="pagination.perPage"
        placeholder="Per page"
      >
        <el-option
          class="select-primary"
          v-for="item in pagination.perPageOptions"
          :key="item"
          :label="item"
          :value="item"
        >
        </el-option>
      </el-select>

      <base-input>
        <el-input
          type="search"
          class="search-input"
          prefix-icon="el-icon-search"
          :placeholder="$t('generic.searchInTablePlaceholder')"
          v-model="searchQuery"
          aria-controls="datatables"
        >
        </el-input>
      </base-input>
    </div>

    <el-table v-loading="loading" :data="queriedData" :empty-text="$t('generic.noData')"
              :row-class-name="tableRowClassName">
      <el-table-column type="expand">
        <template slot-scope="props">
          <inspection-event-details :details="props.row"/>
        </template>
      </el-table-column>
      <el-table-column
        v-for="column in tableColumns"
        :key="column.label"
        :min-width="column.minWidth"
        :prop="column.prop"
        :label="column.label"
        :formatter="column.formatter"
      >
      </el-table-column>
      <!--        <el-table-column align="right" width="50">-->
      <!--          <div slot-scope="props">-->
      <!--            <router-link-->
      <!--              :to="{name: 'account-journey-details', params: {id: props.row.account_id, journey_id: props.row.id.String}}">-->
      <!--              <i class="tim-icons icon-double-right"></i>-->
      <!--            </router-link>-->
      <!--          </div>-->
      <!--        </el-table-column>-->
    </el-table>
    <div slot="footer" class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap">
      <div class="">
        <p class="card-category">
          {{ $t('generic.tablePaginationSummary', {from: from + 1, to: to, total: total}) }}
        </p>
      </div>
      <base-pagination
        class="pagination-no-border"
        v-model="pagination.currentPage"
        :per-page="pagination.perPage"
        :total="total"
      >
      </base-pagination>
    </div>
  </div>
</template>

<script>
import {BaseAlert, BasePagination} from "@/components";
import {Option, Select, Table, TableColumn} from "element-ui";
import {mapActions, mapState} from "vuex";
import Fuse from "fuse.js";
import InspectionEventDetails from "@/components/InspectionEvent/InspectionEventDetails";

export default {

  name: "InspectionEventsTable",
  components: {
    BasePagination,
    BaseAlert,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    InspectionEventDetails
  },
  props: {
    perAccount: {
      type: Boolean,
      required: true,
      description: 'Set this property to true if table should display details for single account.'
    },
  },
  methods: {
    ...mapActions(['LoadAccountInspectionEvents', 'LoadInspectionEvents']),
    tableRowClassName({row, rowIndex}) {
      if (row["status"] === "failure") {
        return 'bg-warning';
      }
      return '';
    },
  },
  computed: {
    ...mapState({
      auditLogResources: state => state.inspection_events.data,
      loading(state) {
        if (this.perAccount) {
          return state.account_inspection_events.loading
        }

        return state.inspection_events.loading
      }
    }),
    /***
     * Returns a page from the searched data or the whole data. Search is performed in the watch section below
     */
    queriedData() {
      let result = this.tableData;
      if (this.searchedData.length > 0) {
        result = this.searchedData;
      }
      return result.slice(this.from, this.to);
    },
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      return this.searchedData.length > 0
        ? this.searchedData.length
        : this.totalCount;
    },
  },
  data() {
    return {
      apiQuery: {
        limit: 300
      },
      pagination: {
        perPage: 50,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50],
        total: 0
      },
      searchQuery: '',
      propsToSearch: ['inspector_team_id', 'system_account_id', 'type', 'status'],
      tableColumns: [
        {
          prop: 'created_at',
          label: this.$t('generic.created'),
          formatter: (row, column, cellValue, index) => {
            return this.$options.filters.time(cellValue)
          },
          minWidth: 80
        },
        {
          prop: 'business_day',
          label: this.$t('generic.business_day'),
          formatter: (row, column, cellValue, index) => {
            return this.$options.filters.dateOnly(cellValue)
          },
          minWidth: 80
        },
        {
          prop: 'inspector_team_id',
          label: this.$t('inspection_event.details.inspector_team_id'),
          minWidth: 120
        },
        {
          prop: 'type',
          label: this.$t('generic.type'),
          minWidth: 60
        },
        {
          prop: 'status',
          label: this.$t('generic.status'),
          minWidth: 60
        },
        {
          prop: 'message',
          label: this.$t('inspection_event.details.message'),
          minWidth: 120
        }
      ],
      tableData: [],
      totalCount: 0,
      searchedData: [],
      fuseSearch: null,
    };
  },
  mounted() {
    let watchTableData = '$store.state.inspection_events.data'
    if (this.perAccount) {
      this.LoadAccountInspectionEvents({id: this.$route.params.id, query: this.apiQuery})
      watchTableData = '$store.state.account_inspection_events.data'
    } else {
      this.LoadInspectionEvents(this.apiQuery)
    }

    this.$watch(watchTableData, function (auditLogs) {
      this.tableData = auditLogs;
      this.totalCount = auditLogs.length;
      // Fuse search initialization.
      this.fuseSearch = new Fuse(this.tableData, {
        keys: ['action', 'created_at', 'resource_kind'],
        threshold: 0.3
      });
    });
  },
  watch: {
    /**
     * Searches through the table data by a given query.
     * NOTE: If you have a lot of data, it's recommended to do the search on the Server Side and only display the results here.
     * @param value of the query
     */
    searchQuery(value) {
      let result = this.tableData;
      if (value !== '') {
        result = this.fuseSearch.search(this.searchQuery);
      }
      this.searchedData = result;
    },
  }
}
</script>

<style scoped>
</style>
